/**
 * Het tabblad Teksten: de teksten die de beheerder heeft klaargezet (sinds
 * stap 18: op elk niveau gemaakt en goedgekeurd), en per tekst een venster
 * om hem op elk niveau te bekijken, met de toetsen (onderdelen/TekstVoorbeeld.js).
 */
import React, { useEffect, useState } from 'react';
import { Eye } from 'lucide-react';
import { leerkrachtApi as api } from '../../../api/leerkracht';
import { genreVan } from '../../../keuzelijsten';
import { TekstVoorbeeld } from '../onderdelen/TekstVoorbeeld';

export function Teksten({ actief, meldFout }) {
  const [teksten, setTeksten] = useState([]);
  const [laden, setLaden] = useState(false);
  const [bekeken, setBekeken] = useState(null);   // het id van de tekst in het venster

  useEffect(() => {
    if (!actief) return;
    setLaden(true);
    api.haalTeksten().then(setTeksten).catch(err => meldFout(err.message)).finally(() => setLaden(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps -- alleen bij het openen van het tabblad
  }, [actief]);

  if (laden) return <p>Laden...</p>;

  return (
    <div className="card">
      <h2 className="mb-16">Beschikbare Teksten</h2>
      {teksten.length === 0 && (
        <p className="text-muted">Er zijn nog geen teksten klaar voor de klas. De beheerder maakt en keurt elke tekst eerst op elk niveau goed.</p>
      )}
      <table>
        <thead>
          <tr>
            <th>Titel</th>
            <th>Beschrijving</th>
            <th>Paragrafen</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {teksten.map(t => (
            <tr key={t.id}>
              <td>
                {t.titel}
                {genreVan(t) && (
                  <span className="badge" style={{ marginLeft: 6, fontSize: 11, color: 'var(--wit)', background: genreVan(t).kleur }}>
                    {genreVan(t).label}
                  </span>
                )}
              </td>
              <td>{t.beschrijving || '-'}</td>
              <td>{t.paragraph_count}</td>
              <td>
                <button className="btn btn-secondary" style={{ padding: '4px 8px' }} onClick={() => setBekeken(t.id)}>
                  <Eye size={14} /> Bekijk
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {bekeken && <TekstVoorbeeld key={bekeken} tekstId={bekeken} onSluit={() => setBekeken(null)} meldFout={meldFout} />}
    </div>
  );
}
